<div class="widget-image card h-100" [ngClass]="cssClass" [attr.id]="id" [style.margin-top]="marginTop" [style.margin-right]="marginRight" [style.margin-bottom]="marginBottom" [style.margin-left]="marginLeft">
  <img class="mw-100" [src]="imageUrl" [attr.alt]="imageDescription">
</div>
